module.exports = __webpack_public_path__ + "img/helicopter_white.46eee100.svg";